const SPKShareTitle = ({ jobTitle }: { jobTitle: string }) => {
  return (
    <div className="flex items-center relative py-4">
      <span className="text-neutral-600 text-sm absolute text-nowrap -top-1 font-light">
        Matching Position
      </span>
      <div className="text-xl font-extrabold pr-4 text-nowrap">{jobTitle}</div>
      <div className="border-b-2 w-full h-1" />
    </div>
  );
};

export default SPKShareTitle;
